import styled from "styled-components";

export const StyledSortByWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

export const StyledSortByContainer = styled.div`
  width: 160px;

  .search-sort-by-dropdown__option-selected {
    width: 155px;
    height: 30px;
    padding: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
